<template>
  <div class="bill-ratio-setting">
    <el-dialog
      title="分账比例配置"
      width="680px"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >

      <el-form ref="formEl" :model="form" :rules="rules" label-width="120px" size="small">
        <el-form-item label="产品项目：">
          <p class="value-text">{{ projectName }}</p>
        </el-form-item>
        <el-form-item label="分账方式：">
          <p v-if="isQUOTA" class="value-text">定额抽佣</p>
          <p v-else-if="isPERCENT" class="value-text">按百分比</p>
          <p v-else class="value-text"> -- </p>
        </el-form-item>
        <el-form-item>
          <div class="info-content">
            <el-row v-if="isQUOTA" type="flex" align="middle" class="top-row-line row-line">
              <el-row type="flex" align="middle" class="left">
                <p class="label">单笔支付金额 大于等于</p>&nbsp;
                <el-input v-model="info.thresholdAmount" readonly placeholder="请输入金额" style="width: 140px">
                  <template slot="append">元</template>
                </el-input>
              </el-row>
              <p class="label">时，按以下规则：</p>
            </el-row>
            <el-row type="flex" align="middle" class="row-line">
              <p class="label left">参与分账方</p>
              <p v-if="isQUOTA" class="value-text">分账额度</p>
              <p v-else-if="isPERCENT" class="value-text">分账比例</p>
            </el-row>
            <el-row v-for="item of info.accountList" :key="item.appId" type="flex" align="middle" class="row-line">
              <p class="label left">{{ item.accountName }}</p>
              <el-input v-if="item.amount !== 'end'" v-model.trim="item.amount" readonly placeholder="请输入金额" style="width: 180px">
                <template slot="append">
                  <span v-if="isQUOTA">元</span>
                  <span v-else-if="isPERCENT">%</span>
                </template>
              </el-input>
              <el-input v-else value="剩余所有额度" readonly style="width: 180px">
                <!-- <template slot="append">
                  <span v-if="isQUOTA">元</span>
                  <span v-else-if="isPERCENT">%</span>
                </template> -->
              </el-input>
            </el-row>
          </div>
          <p class="tips" style="margin-left:-120px">分账额度金额小于单笔支付金额设定值时，剩余资金将归入“剩余所有额度”所在分账方</p>
        </el-form-item>
        <el-form-item label="招生方保证金：" prop="checkAcceptStandard">
          <el-row type="flex" align="middle">
            <el-input v-model.trim="form.checkAcceptStandard" placeholder="请输入金额" style="width: 200px">
              <template slot="append">元/人次</template>
            </el-input>
          </el-row>
          <p class="tips">用于招生销售验收计算</p>
        </el-form-item>
        <el-form-item v-if="type === 2" label="服务方保证金：" prop="agentCheckAcceptStandard">
          <el-row type="flex" align="middle">
            <el-input v-model.trim="form.agentCheckAcceptStandard" placeholder="请输入金额" style="width: 200px">
              <template slot="append">元/人次</template>
            </el-input>
          </el-row>
          <p class="tips">用于招生销售验收计算</p>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="saveing" size="small" type="primary" @click="handleAffirm">保 存</el-button>
        <el-button size="small" @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getSplitContractInfo, updateCheckAcceptStandard } from '@/api/organization'
import { processing } from '@/utils/handle.js'

export default {
  name: 'BillRatioSetting',

  props: {
    type: {
      type: Number,
      required: true
    }
  },
  data () {
    const checkMax = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写验收结算标准!'));
      } else if (value > this.endAmount) {
        callback(new Error('验收结算标准金额不可大于剩余所有额度!'));
      } else {
        callback();
      }
    }
    return {
      dialogVisible: false,
      projectName: '',
      splitType: '',
      info: {},
      form: {
        checkAcceptStandard: '',
        agentCheckAcceptStandard: ''
      },
      rules: {
        checkAcceptStandard: [
          { required: true, message: "请填写验收结算标准!", trigger: "blur" },
        ],
        agentCheckAcceptStandard: [
          { validator: checkMax, trigger: "blur" },
        ]
      },
      saveing: false
    }
  },
  computed: {
    isQUOTA () {
      return this.splitType === 'QUOTA'
    },
    isPERCENT () {
      return this.splitType === 'PERCENT'
    },
    endAmount () {
      const t = this.info
      if (t.thresholdAmount && t.accountList && t.accountList.length !== 0) {
        const e = t.accountList.reduce((prev, next) => {
          const n = next.amount
          return prev - (n === 'end' ? 0 : n)
        }, t.thresholdAmount)
        return e
      }
      return 0
    }
  },
  methods: {
    init (payload) {
      this.form.id = payload.id
      this.projectName = payload.projectName
      this.splitType = payload.splitType
      this.form.checkAcceptStandard = ''
      if (!payload.checkAcceptStandard || payload.checkAcceptStandard === 0) {
        this.form.checkAcceptStandard = payload.checkAcceptStandard
      }
      this.form.agentCheckAcceptStandard = ''
      if (!payload.agentCheckAcceptStandard || payload.agentCheckAcceptStandard === 0) {
        this.form.agentCheckAcceptStandard = payload.agentCheckAcceptStandard
      }
      this.handleGetContractsInfo(payload.splitContractId, this.type)
      this.dialogVisible = true
    },
    // 获取分账比例
    handleGetContractsInfo (splitContractId, flag) {
      getSplitContractInfo({ splitContractId, flag }).then(({ code, data }) => {
        if (code === 0 && data && data.content && data.content.quota) {
          this.info = data.content.quota
        }
      })
    },
    handleAffirm () {
      this.$refs.formEl.validate(valid => {
        if (valid) {
          this.saveing = true
          updateCheckAcceptStandard(processing(this.form)).then(({ code }) => {
            if (code === 0) {
              this.$message.success('分账比例配置成功!')
              this.$emit('refresh')
              this.handleClose()
            }
          }).finally(() => {
            this.saveing = false
          })
        }
      })
    },
    handleClose () {
      this.form = this.$options.data().form
      this.$refs.formEl && this.$refs.formEl.resetFields()
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.info-content {
  margin-left: -120px;
  padding: 16px 12px;
  background-color: #ecf5ff;
  border-radius: 4px;
}
.row-line {
  padding: 8px 0;
  .left {
    width: 294px;
  }
  &.top-row-line {
    padding-bottom: 16px;
    border-bottom: 1px solid #e3e3e3;
  }
}
.tips {
  font-size: 12px;
  color: #666666;
  &.tx-center {
    text-align: center;
  }
}
.desc {
  margin-left: 24px;
}
</style>
